import {
    NinchatActionType,
    NinchatCreateChannelAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatChannelCreatedEvent} from 'api/types/events'

import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createChannel = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateChannelAction}`,
    async (arg: NinchatActionParams<NinchatCreateChannelAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatCreateChannelAction

        try {
            return await ninchatClient.send(params) as NinchatChannelCreatedEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
